import {graph2, api} from '../utils/shared'

export const all_departure_points = async(token) => {
    token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcwMTc4ODE2MiwianRpIjoiMjBjNTNhODktZjliMy00NjI5LThiMzktNWZkYTJhM2ZiYjcxIiwidHlwZSI6ImFjY2VzcyIsInN1YiI6ImFkbWluQGhheXMuY28udWsiLCJuYmYiOjE3MDE3ODgxNjIsImV4cCI6MTczMzMyNDE2Miwicm9sZSI6ImNsaWVudCJ9.mdb3Q5LdxnQbnj0t9gu80Hsv8EaoMmmyHGYabovcRg8'
    let q = `{all_departure_points {result}}`
    let x = await graph2(q, token)
    return x
}
